import pluralize from 'pluralize'
import {Dialog} from '@primer/react'
import {useIsLoading} from '../contexts/IsLoadingContext'
import {useCounts} from '../contexts/CountsContext'

type DeletionDialogProps = {
  returnFocusRef: React.RefObject<HTMLButtonElement | null>
  onCancel(): void
  onConfirm(shouldDelete: boolean): void
}

export function DeletionDialog({returnFocusRef, onCancel, onConfirm}: DeletionDialogProps) {
  const isLoading = useIsLoading()
  const {numberOfEnabledRulesets, numberOfEnabledPreviews} = useCounts()

  return (
    <Dialog
      title="Creating rulesets"
      width="xlarge"
      returnFocusRef={returnFocusRef}
      onClose={onCancel}
      footerButtons={[
        {
          buttonType: 'default',
          content: 'Keep rules',
          onClick: _ev => onConfirm(false),
          loading: isLoading,
        },
        {
          buttonType: 'danger',
          content: 'Delete branch protection rules',
          onClick: _ev => onConfirm(true),
          loading: isLoading,
        },
      ]}
    >
      <Dialog.Body>
        {numberOfEnabledRulesets} {pluralize('ruleset', numberOfEnabledRulesets)} will be created. Would you like to
        delete the {numberOfEnabledPreviews} original branch protection {pluralize('rule', numberOfEnabledPreviews)} now
        covered by rulesets?
      </Dialog.Body>
    </Dialog>
  )
}
